function isEmptyArray(value: unknown): boolean {
    if (!Array.isArray(value)) {
        return true;
    }

    return value.length === 0;
}

// ----------------------------------------------------------------------------

export default isEmptyArray;
